export const applicationRouteSeoInfo = {
  title: 'NIAT | Application',
  description:
    'Start your application on the NIAT Portal. Register for exams, make fee payments, and book slots with ease. Trusted by students and professionals.',
  path: '/application'
};
